import { SagaIterator } from 'redux-saga'
import * as effects from 'redux-saga/effects'
import * as api from './api'
import * as actions from './actions'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'
import history from '../../utils/history'

function* createModule(payload: {
  id: string
  title: string
  position: number
  available_at: string
}): SagaIterator {
  try {
    const { id, title, position, available_at } = payload
    yield effects.call(api.createModule, id, title, position, available_at)
    yield effects.put(actions.createModuleSuccess())
    yield effects.call([history, history.push], `/admin/courses/${id}/modules`)
  } catch (error) {
    console.warn('Cannot create module', error)
    yield effects.put(actions.createModuleFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchCreateModule(): SagaIterator {
  yield effects.takeEvery(actions.createModule.toString(), createModule)
}

export default function* watchAdminModuleCreate(): SagaIterator {
  yield effects.all([effects.fork(watchCreateModule)])
}
